import axios from 'axios';
import * as Interceptors from '../interceptors';

const KMB_API_URL = process.env.KMB_API_URL;

let instance;

export default () => {
  if (instance) {
    return instance;
  }

  const LoaderResponse = Interceptors.loader.response;

  instance = axios.create(
    { baseURL: KMB_API_URL },
  );

  instance.interceptors.request.use(Interceptors.loader.request);

  instance.interceptors.response.use(response => response, Interceptors.token);
  instance.interceptors.response.use(LoaderResponse.success, LoaderResponse.error);

  return instance;
};



// WEBPACK FOOTER //
// ./src/helpers/request/api/instance.js